export default "__VITE_ASSET__DYFu_lS3__"